import { Button, Modal } from 'antd';
import { useState } from 'react';
import { AgendaAppointment } from '../AgendaAppointment';
import { calendarModal, label } from '../../../../constants';

export const NumberAppointment = ({
  appointments = [],
  privileges,
  cabain,
  indexTime,
}) => {
  const [open, setOpen] = useState(false);

  if (appointments.length === 1) {
    const appointment = appointments[0];

    return (
      <AgendaAppointment
        appointment={appointment}
        privileges={privileges}
        cabain={cabain}
        indexTime={indexTime}
      />
    );
  }

  return (
    <>
      <Button
        type="link"
        onClick={() => setOpen(true)}
        style={{
          width: '100%',
          height: '100%',
          background: '#e6f4ff',
          border: '1px solid #91caff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 0,
        }}
      >
        <span style={{ color: '#1d39c4', fontWeight: 500 }}>
          {label.numberAppointment(appointments.length)}
        </span>
      </Button>

      <Modal
        title={calendarModal.title}
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        width={300}
      >
        {appointments.map((appointment, index) => (
          <AgendaAppointment
            key={`${appointment.id}-${appointment.startTime}-${appointment.date}-${index}`}
            appointment={appointment}
            privileges={privileges}
            cabain={cabain}
            indexTime={indexTime}
          />
        ))}
      </Modal>
    </>
  );
};
